export default __webpack_public_path__ + "static/media/ai_coach.20111935.svg";